import { useUserLoanDetails } from './useUserLoanDetails';

export default function useMonthlyPayment(price: number): number {
  const { userLoanDetailsState } = useUserLoanDetails();
  let principal = 0;

  if (userLoanDetailsState.shouldUseDownPaymentPercentage) {
    principal = price - price * (userLoanDetailsState.downPaymentPercentage / 100);
  } else {
    principal = price - userLoanDetailsState.downPayment;
  }
  if (principal <= 0) return 0;

  const interestRate: number = userLoanDetailsState.interestRate / 100;
  const basePayment: number = (principal * interestRate) / 12;
  const interest: number = (1 + interestRate / 12) ** userLoanDetailsState.loanDuration;

  return Math.round((basePayment * interest) / (interest - 1));
}
